import React from "react";

import { CONTENT_MAX_WIDTH_STYLE } from "@/src/constants/size";
import { cn } from "@/src/lib/utils";

import type { JSX, ReactNode } from "react";

interface CappedPageProps {
  children: ReactNode;
  contentClassName?: string;
}

function CappedPage({
  children,
  contentClassName,
}: CappedPageProps): JSX.Element {
  return (
    // overflow-x-hidden absorbs a 1px rounding overflow when the max-width centering kicks in
    <div className="flex size-full flex-col overflow-x-hidden overflow-y-auto px-4 md:px-8">
      <div
        className={cn("mx-auto w-full max-w-(--maxWidth)", contentClassName)}
        style={CONTENT_MAX_WIDTH_STYLE}
      >
        {children}
      </div>
    </div>
  );
}

export default CappedPage;
